export default "__VITE_ASSET__D4uw7svq__"